import { Client } from "@/Common/Api/Client";
import { ClientResponse } from "@/Common/Api/ClientResponse";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { AccountDetailsResponse } from "./Dto/AccountDetailsResponse";
import { AddIndividualContactRequest } from "./Dto/AddIndividualContactRequest";
import { SaveIndividualDemographicsRequest } from "./Dto/SaveIndividualDemographicsRequest";
import { SendInvitationRequest } from "./Dto/SendInvitationRequest";
import { SendInvitationResponse } from "./Dto/SendInvitationResponse";
import { SendMessageRequest } from "./Dto/SendMessageRequest";
import { SendMessageResponse } from "./Dto/SendMessageResponse";
import { SyncMessagesRequest } from "./Dto/SyncMessagesRequest";

const getAccountDetails = async (contactId: string): Promise<AccountDetailsResponse> => {
    const response = await Client
        .postAsync<{
        AccountDetails: AccountDetailsResponse
    }>(ServerOperations.Server.Portal_GetPortalAccountInfo, {
        ContactId: contactId
    });

    if (!response.isSuccess) {
        throw new Error(response.errors.at(0).Message);
    }

    return response.data.AccountDetails;
};

const sendInvitation = async (data: SendInvitationRequest): Promise<ClientResponse<SendInvitationResponse>> => await Client
    .postAsync<SendInvitationResponse>(ServerOperations.Server.Portal_SendInviteForRegistration, data);

const syncMessages = async (data: SyncMessagesRequest): Promise<ClientResponse<unknown>> => await Client
    .postAsync(ServerOperations.Server.Myle_Patient_Portal_SyncSharedItem, data);

const sendMessage = async (data: SendMessageRequest): Promise<ClientResponse<SendMessageResponse>> => await Client
    .postAsync<SendMessageResponse>(ServerOperations.Server.Myle_Patient_History_CreateCommunication, data);

const refuseInvitation = async (contactId: string): Promise<ClientResponse<unknown>> => await Client
    .postAsync(ServerOperations.Server.Portal_RefusePatientAccountStatus, { contactId });

const saveIndividualDemographics = async (data: SaveIndividualDemographicsRequest): Promise<ClientResponse<unknown>> => await Client
    .postAsync(ServerOperations.Server.Myle_Individual_Demographics_Update, data);

const addIndividualContact = async (data: AddIndividualContactRequest): Promise<ClientResponse<unknown>> => await Client
    .postAsync(ServerOperations.Server.Myle_Individual_AddContact, data);

export {
    addIndividualContact,
    getAccountDetails,
    refuseInvitation,
    saveIndividualDemographics,
    sendInvitation,
    sendMessage,
    syncMessages };
